import React, { useState, useEffect } from 'react';
import { EntitySearchContainer } from '../components/entity-search.container';
import { EntitySearchFilterContainer } from '../components/entity-search-filter.container';
import FilterMenuToggle from '../../../shared/filter-menu-toggle';
import { StaffEntitySearchContainerEntitySearchFacetsFieldsFragment } from '../../../../generated';
import { CheckFilterInterface } from '../components/entity-search-filter';

export const EntitySearch: React.FC<any> = (_props) => {
  const [filters, setFilters] = React.useState<CheckFilterInterface>({
    updatedAt: [],
    disabledAt: [],
    createdAt: [],
    country: [],
    schemaVersion: [],
    isClient: null,
    isClientYesChecked: true,
    isClientNoChecked: false,
    isIssuingInstitution: null,
    isIssuingInstitutionYesChecked: true,
    isIssuingInstitutionNoChecked: false
  });
  const [filterDataCount, setFilterDataCount] = React.useState<StaffEntitySearchContainerEntitySearchFacetsFieldsFragment>({});
  const [isMobile, setIsMobile] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div>
      {isMobile && (
        <FilterMenuToggle 
          isOpen={filterMenuOpen}
          onToggle={() => setFilterMenuOpen(!filterMenuOpen)} 
        />
      )}

      <div className={`flex flex-col text-left ${isMobile ? 'px-0' : 'px-5'}`}>
        <div className={`flex ${isMobile ? 'flex-col' : 'flex-row'} overflow-x-auto gap-5 whitespace-nowrap mt-5`}>
          {(filterMenuOpen || !isMobile) && (
            <EntitySearchFilterContainer setFilters={setFilters} filterDataCount={filterDataCount} />
          )}
          <EntitySearchContainer isMobile={isMobile} filters={filters} setFilterDataCount={setFilterDataCount} />
        </div>
      </div>
    </div>
  );
};
